import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { Component, DestroyRef, Input, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';

import { SettingsPopupComponent } from '@cabinet/components/settings-popup/settings-popup.component';
import { InviteModel } from '@core/models/invite.model';
import { UserModel } from '@core/models/user.model';
import * as fromRoot from '@core/redux';
import { TaskQueryService } from '@core/services/query/task.query.service';
import { select, Store } from '@ngrx/store';
import { AvatarComponent } from '@ux/components/avatar/avatar.component';

@Component({
  selector: 'app-sidebar-user',
  templateUrl: './sidebar-user.component.html',
  styleUrls: ['./sidebar-user.component.less'],
  imports: [AvatarComponent, DialogModule],
  standalone: true,
})
export class SidebarUserComponent {
  private readonly store = inject<Store<fromRoot.State>>(Store);
  private readonly taskQueryService = inject(TaskQueryService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);

  dialog = inject(Dialog);

  @Input() inviteList: InviteModel[];

  isAdmin = signal<boolean>(false);

  constructor() {
    // Подписка на права администратора
    this.store
      .pipe(select(fromRoot.getUserCanAdmin), takeUntilDestroyed(this.destroyRef))
      .subscribe((isAdmin: boolean) => this.isAdmin.set(isAdmin));
  }

  /**
   * Открыть настройки пользователей, форма приглашения
   */
  onOpenSettings(): void {
    this.dialog.open<SettingsPopupComponent>(SettingsPopupComponent, {
      data: {
        tab: 'user',
      },
    });
  }

  /**
   * Фильтрация задач по пользователю (исполнителю задачи)
   */
  onFilterByUser(user: UserModel): void {
    this.taskQueryService.toggleResponsible(user.id);
  }

  /**
   * Активированный пользователь
   */
  getInActive(user: UserModel): boolean {
    return this.taskQueryService.isActiveResponsible(user.id);
  }
}
